<template>
  <div id="app">
    <div class="main">
      <div align="center" style="padding-bottom:20px;"><img :src="logo" width="75"></div>


      <div class="box">
        <!-- <div id="nav">
        <router-link to="/">Home</router-link> |
          <router-link to="/about">About</router-link>
        </div>-->

        <div class="maincontent">
          <router-view/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'System Nexa 2',
    meta: [
      { name: 'viewport', content: 'width=device-width, initial-scale=1' }
    ]
  },
  computed: {
    logo () {
      return require('@/assets/googlehome_small.png')
    }
  }
}
</script>

<style>
/* Import Font */
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;500;600&display=swap');

/* CSS Variables - Base Theme */
:root {
  --bg-color: #f9f9f9;
  --text-color: #000;
  --card-bg: #fff;
  --border-color: #ebebeb;
  --input-border: rgba(0, 0, 0, 0.02);
  --input-border-focus: rgba(0, 0, 0, 0.18);
  --button-bg: #04325B;
  --button-disabled: #e3e3e3;
  --error-bg: #e74c3c;
  --spacing-unit: 10px;
  --border-radius: 4px;
  --input-bg: rgba(136, 126, 126, 0.04);
  --placeholder-opacity: 0.5;
}

/* Dark Theme */
@media (prefers-color-scheme: dark) {
  :root {
    --bg-color: #1a1b26;
    --text-color: #a9b1d6;
    --card-bg: #24283b;
    --border-color: transparent;
    --input-border: #a9b1d6;
    --input-border-focus: #a9b1d6;
    --button-bg: #7aa2f7;
  }
}

/* Reset & Base Styles */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Open Sans', system-ui, -apple-system, sans-serif;
  font-size: 13px;
  line-height: 1.5;
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--bg-color);
  color: var(--text-color);
}

/* Layout Components */
.main {
  width: 100%;
  max-width: 400px;
  min-height: 200px;
}

.box {
  border-radius: var(--border-radius);
  border: 1px solid var(--border-color);
  background-color: var(--card-bg);
}

.maincontent {
  padding: var(--spacing-unit);
}

/* Typography */
h3 {
  font-size: 1.5rem;
  margin-bottom: var(--spacing-unit);
  color: var(--text-color);
}

p {
  margin: var(--spacing-unit) 0;
}

.title {
  text-align: center;
}

/* Form Elements */
.input {
  width: 100%;
  color: var(--text-color);
  font-size: 14px;
  letter-spacing: 1px;
  background: var(--input-bg);
  padding: var(--spacing-unit);
  border: 1px solid var(--input-border);
  border-radius: 6px;
  margin-bottom: 15px;
  transition: border-color 0.3s ease;
  outline: none;
}

.input:focus {
  border-color: var(--input-border-focus);
}

/* Placeholder Styles */
::placeholder {
  color: var(--text-color);
  opacity: var(--placeholder-opacity);
}

:-ms-input-placeholder {
  color: var(--text-color);
  opacity: var(--placeholder-opacity);
}

::-ms-input-placeholder {
  color: var(--text-color);
  opacity: var(--placeholder-opacity);
}

/* Button Styles */
.submit {
  cursor: pointer;
  border-radius: var(--border-radius);
  color: #fff;
  background: var(--button-bg);
  border: 0;
  padding: var(--spacing-unit) 40px;
  font-size: 14px;
  font-weight: bold;
  transition: opacity 0.3s ease, background-color 0.3s ease;
  box-shadow: 0 0 20px 1px rgba(0, 0, 0, 0.04);
}

.submit:disabled {
  background: var(--button-disabled);
  cursor: not-allowed;
  opacity: 0.7;
  box-shadow: none;
}

.submit:hover:not(:disabled) {
  opacity: 0.9;
}

/* Alert Styles */
.error {
  padding: calc(var(--spacing-unit) * 0.8);
  background: var(--error-bg);
  border-radius: var(--border-radius);
  color: #fff;
}

/* Mobile Optimizations */
@media (max-width: 768px) {
  .main {
    width: 95vw;
    margin: var(--spacing-unit);
  }
  
  .box {
    border-radius: 0;
  }
}
  
</style>
